import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import React, { useState } from 'react'
import RichTextEditor from 'react-rte'
import { NoteType } from './NoteType';
import { NoteReviewer } from './NoteReviewer';
import { NoteLabel } from './NoteLabel';
import { TaggedPM } from './TaggedPM';
import { FlagFileModel } from './FlagFileModel';
import { NotesAttached } from './NotesAttached';
import { useReportUpdateNote } from '../../../common/CommonMutations';
import { useFetchContext } from '../../../common/FetchContext';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useReportComments } from '../../../common/CommonQueries';
import { ReportComments } from './ReportComments';

export const NotesFlag = ({ id, noteId, open, text, onClose, onSubmit }: any) => {
    const [openComment, setOpenComment] = React.useState(false);

    const [usedLabels, setUsedLabels] = useState<any[]>([]);
    const [selectedNoteType, setSelectedNoteType] = React.useState<any>("");

    const [taggedReviewer, setTaggedReviewer] = React.useState<any>(null);

    const [ProjectManagers, setProjectManagers] = React.useState<any[]>([]);
    const [editorContent, setEditorContent] = useState(
        RichTextEditor.createValueFromString(text?.comment || "", 'markdown')
    );

    const [newComment, setNewComment] = React.useState(
        RichTextEditor.createEmptyValue()
    );
    React.useEffect(() => {
        if (text?.comment) {
            setEditorContent(RichTextEditor.createValueFromString(text.comment, 'markdown'));
        }
    }, [text]);

    const { mutateAsync: mutateNote } = useReportUpdateNote();
    const { authAxios } = useFetchContext();
    const queryClient = useQueryClient();
    const {
        data: comments,
        isError: isErrorComments,
        isLoading: isLoadingComments,
        error: errorComments,
    } = useReportComments(noteId);



    const handleChange = (value: any) => {
        setNewComment(value);
    }




    const renderUpdate = () => {
        if (
            newComment.toString("markdown").length > 2
        ) {
            if
                (
                newComment.toString("markdown").length < 9
            ) {
                return <Button disabled>Update</Button>;
            } else {
                return (
                    <Button onClick={handleUpdate} color="primary">
                        Update
                    </Button>
                );
            }
        } else {
            return <Button disabled>Update</Button>;
        }
    };

    const renderComment = () => {
        if (openComment) {
            return (
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="flex-start"
                    spacing={1}
                >
                    <Grid xs={9} item>
                        <RichTextEditor
                            value={newComment}
                            onChange={handleChange}
                            toolbarConfig={{
                                display: [
                                    "BLOCK_ALIGNMENT_BUTTONS",
                                    "INLINE_STYLE_BUTTONS",
                                    "BLOCK_TYPE_BUTTONS",
                                    "BLOCK_TYPE_DROPDOWN",
                                    "HISTORY_BUTTONS",
                                ],
                                BLOCK_ALIGNMENT_BUTTONS: [
                                    { label: 'UL', style: 'unordered-list-item' },
                                    { label: 'OL', style: 'ordered-list-item' },
                                    { label: 'Blockquote', style: 'blockquote' },
                                ],
                                INLINE_STYLE_BUTTONS: [
                                    { label: "Bold", style: "BOLD" },
                                    { label: "Italic", style: "ITALIC" },
                                    { label: "Strikethrough", style: "STRIKETHROUGH" },
                                    { label: "Monospace", style: "CODE" },
                                    { label: "Underline", style: "UNDERLINE" },
                                ],
                                BLOCK_TYPE_DROPDOWN: [
                                    { label: "Normal", style: "unstyled" },
                                    { label: "Heading Large", style: "header-one" },
                                    { label: "Heading Medium", style: "header-two" },
                                    { label: "Heading Small", style: "header-three" },
                                ],
                                BLOCK_TYPE_BUTTONS: [
                                    { label: "UL", style: "unordered-list-item" },
                                    { label: "OL", style: "ordered-list-item" },
                                    { label: "Blockquote", style: "blockquote" },
                                ],
                            }}
                        />
                    </Grid>

                    <>
                        <Grid item xs={2}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setNewComment(RichTextEditor.createEmptyValue());
                                    setOpenComment(false);
                                }}
                            >
                                CLEAR
                            </Button>
                        </Grid>
                    </>

                </Grid>
            );
        } else {
            return null;
        }
    };





    const handleUpdate = async () => {
        try {
            const labelIds = usedLabels.map((label) => label.id);
            const taggedReviewerIds = ProjectManagers.map((pm) => pm.id);



            // console.log("Submitting payload:", payload);

            await mutateNote({
                authAxios,
                id: text.id,
                type: selectedNoteType,
                subject: text.subject,
                comment: newComment.toString("markdown"),
                reviewer: taggedReviewer?.id,
                labels: labelIds,
                tagged_users: taggedReviewerIds,
                report: id,
            });
            queryClient.invalidateQueries(['report-comments', noteId]);
            setNewComment(RichTextEditor.createEmptyValue())
            setUsedLabels([]);
            setSelectedNoteType("")
            setTaggedReviewer(null);
            setProjectManagers([]);
            setOpenComment(false);

            // toast.info("Coming soon");
            toast.success("Flag submitted successfully.");
            // onClose();
        } catch (error) {
            console.error(error);
            toast.error("Failed to submit flag.");
        }
    };



    return (
        <div>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
                <DialogTitle>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                    >

                        <>
                            <Grid item xs={7}>
                                <Typography variant="h6">Note</Typography>
                            </Grid>
                            <Grid item xs={1}>
                                <Typography variant="body2" display="inline">
                                    Note ID:
                                </Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <Button
                                    style={{ textAlign: "center" }}
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                >
                                    {text?.id}
                                </Button>
                            </Grid>
                            <Grid item xs={1}>
                                <IconButton onClick={onClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Grid>
                        </>


                    </Grid>

                </DialogTitle>
                <DialogContent>
                    <Divider variant="fullWidth" />

                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start"
                        spacing={1}
                    >
                        <Grid item xs={9}>

                            <Grid container spacing={1}>
                                <Grid item xs={7}>
                                    <Typography variant="h6">{text.subject}</Typography>

                                </Grid>
                                <Grid item xs={2}>
                                    From : {text.user_name}

                                </Grid>
                                <Grid item xs={3}>
                                    At : {new Date(text.datetime).toLocaleString()}

                                </Grid>
                            </Grid>

                            <Grid item xs={9} style={{ marginTop: '5px' }}>
                                <Typography variant="h6">{text.comment}</Typography>
                            </Grid>
                            <Divider variant="fullWidth" />
                            <Grid item xs={9} style={{ marginTop: '5px' }}>
                                {isLoadingComments ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <Typography variant="h6">
                                        FileName: {comments?.version?.Name || "N/A"}
                                    </Typography>
                                )}

                            </Grid>


                            <Grid item xs={9} style={{ marginTop: '5px', marginBottom: '5px' }}>
                                <>
                                    <ReportComments comments={comments?.result} text={text} />
                                    {/* {renderWarn()} */}
                                    {/* {renderComment()} */}
                                </>
                            </Grid>

                            {selectedNoteType === 3 ? (
                                <Grid item xs={9}>
                                    <RichTextEditor value={newComment} onChange={handleChange} />
                                </Grid>
                            ) : <Grid item xs={9}>
                                <>
                                    {renderComment()}
                                </>
                            </Grid>}
                        </Grid>




                        <Grid
                            item
                            xs={3}
                            style={{
                                borderLeftStyle: "solid",
                                borderWidth: "2px",
                            }}
                        >
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                alignItems="stretch"
                                spacing={1}
                            >


                                {/* <Grid item xs={12}>
                                    <NotesAttached />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <NoteType
                                        noteTypes={selectedNoteType}
                                        setNoteTypes={setSelectedNoteType}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <NoteReviewer
                                        taggedReviewer={taggedReviewer}
                                        setTaggedReviewer={setTaggedReviewer}
                                        isNew={true}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TaggedPM
                                        projectManagers={ProjectManagers}
                                        setprojectManagers={setProjectManagers}
                                        isNew={true}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <NoteLabel
                                        usedLabels={usedLabels}
                                        setUsedLabels={setUsedLabels}
                                    />
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <FlagFileModel />
                                </Grid> */}

                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>

                    <Button onClick={onClose} color="primary">
                        Close
                    </Button>

                    {/* {openComment ? (
                        <Button
                            disabled
                        >
                            Comment
                        </Button>
                    ) : (
                        <Button
                            color="secondary"
                            onClick={() => {
                                setOpenComment(!openComment);
                            }}
                        >
                            Comment
                        </Button>
                    )} */}
                    {selectedNoteType === 3 ? (
                        <Button disabled>
                            Comment
                        </Button>
                    ) : openComment ? (
                        <Button disabled>
                            Comment
                        </Button>
                    ) : (
                        <Button
                            color="secondary"
                            onClick={() => {
                                setOpenComment(true);
                            }}
                        >
                            Comment
                        </Button>
                    )}

                    {renderUpdate()}

                </DialogActions>
            </Dialog>

        </div>
    )
}


